import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
import { workflowItemProcessedSnackbarDuration } from '@/warehouse/constants';
import { createAppAsyncThunk } from '@/warehouse/helpers';
import { crossdockReceiptApi } from '../crossdockReceipt.api';
const confirmReceiptItem = createAppAsyncThunk('receipt/confirmReceiptItem', async (receiptItem, { dispatch, rejectWithValue }) => {
    // TODO: check. Mb use redux store (`common` slice, for example) instead of zustand?
    const { setSearchTerm } = useItemWorkflowTableStore.getState();
    try {
        // A single snackbar is allowed at one moment.
        closeSnackbar();
        // Clear search text field BEFORE `confirmReceiptItem` endpoint call, not at the end of this thunk.
        // That's important to avoid bug (https://global-parts.atlassian.net/browse/GPI-367) when cursor jumps to the next row that
        // meets the search criteria.
        // `ReceiptItemsTable` reacts on `data` has been changed (in `confirmReceiptItem` onQueryStarted optimistic update
        // of `item.receiptedQuantity`) and in case the search term still exists relocates currents selection to another row.
        setSearchTerm('');
        await dispatch(crossdockReceiptApi.endpoints.confirmReceiptItem.initiate(receiptItem)).unwrap();
        enqueueSnackbar({
            // Should not prevent duplicate since another quantity of the same article may be confirmed.
            // key: receiptItem.receiptItemId,
            // preventDuplicate: true,
            variant: receiptItem.isBlocked ? 'receiptBlockSuccess' : 'receiptSubmissionSuccess',
            brand: receiptItem.brand,
            article: receiptItem.article,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: workflowItemProcessedSnackbarDuration,
        });
        // Should not be used here, see comment above.
        // setSearchTerm('');
    }
    catch (error) {
        const errorData = error.data;
        if (errorData?.Message?.includes('The received quantity more that available')) {
            // TODO: later. Get rid of this when new backend will be ready.
            enqueueSnackbar({
                variant: 'error',
                header: receiptItem.isBlocked ? t('receipt.item.block.failed') : t('receipt.item.reception.failed'),
                body: receiptItem.isBlocked ? t('blocked.quantity.more.than.available') : t('received.quantity.more.than.available'),
                persist: false,
            });
        }
        else {
            enqueueSnackbar({
                variant: 'error',
                header: receiptItem.isBlocked ? t('receipt.item.block.failed') : t('receipt.item.reception.failed'),
                body: getErrorFromException(error),
                persist: true,
            });
        }
        console.error(`Receipt item ${receiptItem.isBlocked ? 'block' : 'confirm'} error:`, error);
        if (error instanceof Error) {
            return rejectWithValue(`Cannot confirm receipt item: ${error.message}`);
        }
        return rejectWithValue('Server unexpected error');
    }
});
export { confirmReceiptItem };
